
if(document.getElementById('modal-solicitar-infos')) {
	// Vue.component('example', require('./components/Example.vue'));


	// const app = new Vue({
	//     el: '#modal-solicitar-infos',
	//     data: function (){

	//     	return {}
	//     },
	//     methods: {
	//       fechar () {
	//        	$('#modal-solicitar-infos').hide();
	//         window.localStorage.setItem('fechou-experiencia', 1);

	// 		if (ga) ga('send', 'event', 'Salvar-Dados-Fechar', 'Listagem');
	//       },

	//       salvarDados: function() {

	//       	var that = this;
	// 		if ($('#modal-solicitar-infos #modal-email').val() == '') {
	// 			alert('Informe seu e-mail!');
	// 			return false;
	// 		}	      	
	// 		if ($('#modal-solicitar-infos #modal-nome').val() == '') {
	// 			alert('Informe seu nome!');
	// 			return false;
	// 		}	      	
	// 		if ($('#modal-solicitar-infos #modal-telefone').val() == '') {
	// 			alert('Informe seu telefone!');
	// 			return false;
	// 		}	      	


	// 		var btn = $('#modal-solicitar-infos').find('.form-input-group .btn');
	// 		var btnHtml = btn.attr('disabled',true).html();
	// 		btn.css('width','76px').html('<i class="fa fa-spin fa-spinner"></i>');


	// 		$.ajax({
	// 			url: $('#modal-solicitar-infos form').attr('action'),
	// 			type: 'POST',
	// 			data: {
	// 				nome: $('#modal-solicitar-infos #modal-nome').val(),
	// 				email: $('#modal-solicitar-infos #modal-email').val(),
	// 				telefone: $('#modal-solicitar-infos #modal-telefone').val()
	// 			},
	// 		})
	// 		.done(function() {

	// 			if (ga) ga('send', 'event', 'Salvar-Dados-Sucesso', 'Listagem');

	// 	        btn.css('width','170px').html('Sucesso!');
	// 	        setTimeout(function() {
	// 	        	btn.css('width','170px').html(btnHtml);
	// 	        }, 1200);

	// 	        $('#modal-solicitar-infos').hide();
	// 	        window.localStorage.setItem('fechou-experiencia', 1)
	// 		});
			

	//       }
	//     },


	//     mounted: function() {


	//     	if ($('.imovel-cidade-operacao-tipo-route')[0] && !window.localStorage.getItem('fechou-experiencia') && window.localStorage.getItem('paginas-experiencia') > 1) {
	//     		setTimeout(function() {
	//     			$('#modal-solicitar-infos').show();
	//     		}, 7000)
	//     	}

	//     	var paginas = (window.localStorage.getItem('paginas-experiencia') == null || window.localStorage.getItem('paginas-experiencia') == 'NaN') ? 0 : window.localStorage.getItem('paginas-experiencia');

	//     	window.localStorage.setItem('paginas-experiencia', parseInt(paginas)+1)
	//     }

	// });

}